import { Component, OnInit } from "@angular/core";
import { DataService } from "../data.service";
import { CountryService } from "../country.service";
import { Router, ActivatedRoute } from "@angular/router";
import { IMyDpOptions, IMyDateModel, IMyDate } from "mydatepicker";
import { NgForm } from "@angular/forms";
import { EventsService } from "angular4-events";
import { Constants } from "../constants";

declare var $: any;
declare var Nanobar: any;
declare var google: any;
declare var toastr: any;

@Component({
  selector: "app-driver-detail",
  templateUrl: "./driver-detail.component.html",
  styleUrls: ["./driver-detail.component.css"],
})
export class DriverDetailComponent implements OnInit {
  priceIconForDouble = Constants.iconForDoublePrice;
  id: number;
  private sub: any;
  nao = new Nanobar();
  countryCode: any;
  countryCode2: any;
  btnDisable = false;
  first_name: any;
  last_name: any;
  phone: any;
  phone2 = "";
  email: any;
  enableEditAccess: boolean;
  addDriverData: any;
  dob: any;
  address_line1: any;
  address_line2: any;
  city: any;
  state: any;
  zip: any;
  area: any;
  note: any;
  driving_license_front: any;
  driving_license_back: any;
  registration_book: any;
  success: any;
  addDriver = false;
  place: any;
  error_count: any;
  emailChk: any;
  addingError: any;
  latitude: any;
  longitude: any;
  street: any;
  findDriverData: any;
  driverMatch = true;
  dispenseries: any;
  numChk = false;
  validateNumberSucces: any;
  validateChk = true;
  phoneNumToSend: any;
  userImage: any;
  clearTimeout: any;
  placeSuggestionsData: any;
  placeDetailData: any;
  placeDataFound = false;
  addressLoad = false;
  dobToDisplay: any;
  private today = new Date();
  selDate: any;
  selectAddress = false;
  myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: "mm/dd/yyyy",
    showTodayBtn: true,
    todayBtnTxt: "Today",
    showClearDateBtn: false,
    indicateInvalidDate: true,
    editableDateField: false,
    openSelectorOnInputClick: true,
    disableSince: { year: this.today.getFullYear() - 20, month: 1, day: 1 },
    // minYear: this.today.getFullYear() - 20,
    // disableSince: {year: this.today.getFullYear(), month: this.today.getMonth() + 1, day: this.today.getDate() + 1}
    // disableUntil: {year: 0, month: 0, day: 0}
  };
  idval: any;
  previousState: any;

  showRangeFields = false;
  ordertype = 0;
  filterValue = "Order-All";
  searchOrder = "";
  noSearchData = false;
  searchTimeOut: any;
  startDate: any;
  endDate: any;
  filter_id: number = -1;
  customerOrderListing: any = [];
  loadingData = true;
  lastPageHistory: boolean = true;
  driverOrder: any;
  driverOrderListing: any;
  page: number = 0;
  pagination: any;
  serviceCityForOrders: string = 'Services-All';
  serviceCityIdForOrders: any;
  serviceCity: string;
  businessDetailforOrder: any;
  searchBusinessDetailforOrder: any;
  businessForOrders: string = 'Businesses-All';
  dispensary_id: any;
  businessName: string;
  completeOutletData: any;
  outletDatas: any;
  outletName: string;
  outletId: number;
  status: any;
  dataOrdersListing: any;
  lastPage: any;
  pageOrder: any;
  limitOrders: any;
  city_id: any;
  outletDayindex: any;
  selectionDayOpenTime: any;
  selectionDayCloseTime: any;
  servicesDatas: any;
  searchBusiness: any;
  showSearchResults: boolean;
  businessIdForOrders: number = -1;
  dateType: number = -1;
  totalOrders: any;
  orderDetailToReopenOpId: any;
  orderDetailData: any;
  customerDetail: any;
  droppOffAddress: any;
  userDropDocs: any;
  orderDataDisplay: any;
  dineIn: boolean;
  tableNo: any;
  pickUp: boolean;
  pickupAddress: any;
  thirdPartyData: any;
  productData: any;
  onDetailDriverData: any;
  returnOrderItems: any;
  returnOrderItemsLength: any;
  orderCreated: any;
  orderBooked: any;
  deliverStartDate: Date;
  deliverEndDate: Date;
  enableQuantity:any;
  enableorder:any;
  _none: string = "";
  paginationBtn: boolean = false;
  constructor(
    private route: ActivatedRoute,
    private cs: CountryService,
    private dataService: DataService,
    private router: Router,
    private events: EventsService
  ) {
    this.dataService.pageName = "driver detail";
    this.sub = this.route.params.subscribe((params) => {
      this.id = +params["id"]; // (+) converts string 'id' to a number
      console.log("this.id", this.id);
    });
    this.idval = this.events.subscribe("driversListing").subscribe((data) => {
      this.id = data.id;
      this.previousState = data;
      this.driverDetails();
      this.getServices();
      this.getOrderHistory();
    });
  }
  findNumber() {
    if (this.phone2 === null || this.phone2 === "") return;
    this.numChk = true;
    this.nao.go(30);
    var getCode = $("#phone").intlTelInput("getSelectedCountryData").dialCode;
    var num = "+" + getCode + this.phone2;
    console.log("number", num);
    console.log("login data");
    this.dataService
      .validateNumber(window.localStorage.getItem("token"), num)
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.validateNumberSucces = data;
          this.validateNumberSucces = this.validateNumberSucces.success;
          this.validateChk = this.validateNumberSucces;
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
        }
      );
  }
  driverDetails() {
    this.nao.go(30);
    this.ordertype = 0;
    this.filterValue = "Order-All";
    this.showRangeFields = false;
    console.log("login data");
    this.dataService
      .showDriverDetailWithId(window.localStorage.getItem("token"), this.id)
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.findDriverData = data;
          this.dispenseries = data;
          this.dispenseries = this.dispenseries.dispensaries;
          if (this.findDriverData.rest_error_code === 1)
            toastr.error("Something went wrong");
          if (this.findDriverData.rest_error_code === 2)
            toastr.error("Please login again");
          if (this.findDriverData.rest_error_code === 3)
            toastr.error("Driver already exists");
          this.findDriverData = data;
          // $('#datepicker').val(this.findDriverData.date_of_birth);
          this.dobToDisplay = this.findDriverData.date_of_birth;
          this.selDate = this.findDriverData.date_of_birth;
          this.first_name = this.findDriverData.first_name;
          this.last_name = this.findDriverData.last_name;
          this.email = this.findDriverData.email;
          this.enableEditAccess = this.findDriverData.edit_order_access;
          this.enableQuantity  = this.findDriverData.edit_quantity_acsess;
          this.enableorder =  this.findDriverData.create_order_access;
          this.phone = this.findDriverData.phone_number;
          this.phone2 = this.findDriverData.phone_number;
          this.countryCode = this.findDriverData.country_code;
          this.phoneNumToSend =
            this.countryCode + this.findDriverData.phone_number;
          this.note = this.findDriverData.note;
          this.street = this.findDriverData.street;
          this.userImage = this.findDriverData.img_url;
          if (
            this.findDriverData.city !== null &&
            this.findDriverData.city !== "" &&
            this.findDriverData.address_line1 !== null &&
            this.findDriverData.address_line1 !== ""
          ) {
            this.selectAddress = true;
            this.callMap();
          } else {
            this.selectAddress = false;
          }
          $("#pImg1").attr("src", this.findDriverData.licence_front_url);
          $("#pImg2").attr("src", this.findDriverData.licence_back_url);
          $("#pImg3").attr("src", this.findDriverData.reg_book_url);
          // this.driving_license_front = this.findDriverData.licence_front_url;
          // this.driving_license_back = this.findDriverData.licence_back_url;
          // this.registration_book = this.findDriverData.reg_book_url;
          this.findDriverData = this.findDriverData.address;
          this.address_line1 = this.findDriverData.address_line1;
          this.address_line2 = this.findDriverData.address_line2;
          console.log("this.userImage", this.userImage);
          this.city = this.findDriverData.city;
          this.state = this.findDriverData.state;
          this.zip = this.findDriverData.zip;
          this.area = this.findDriverData.area;
          this.longitude = this.findDriverData.longitude;
          this.latitude = this.findDriverData.latitude;
          this.driverMatch = true;
          console.log("cutomer data get with phone#", data);
          // }
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
        }
      );
  }
  // addressDetail() {
  // this.street = '';
  // console.log('chk address detail', this.place);
  //    for(var i = 0; i < this.place.address_components.length; i++) {
  //   for(var j = 0; j < this.place.address_components[i].types.length; j++) {
  //     // if (this.place.address_components[i].types[j] === 'administrative_area_level_2') {
  //     //   // this.city = this.place.address_components[i].long_name;
  //     //   // console.log('city', this.city);
  //     //    $('#city').val(this.place.address_components[i].long_name);
  //     // }
  //     if (this.place.address_components[i].types[j] === 'locality') {
  //       // this.city = this.place.address_components[i].long_name;
  //       // console.log('city', this.city);
  //        $('#city').val(this.place.address_components[i].long_name);
  //     }
  //      if (this.place.address_components[i].types[j] === 'street_number') {
  //       this.street = this.place.address_components[i].long_name;
  //       console.log('street number', this.street);
  //     }
  //     if (this.place.address_components[i].types[j] === 'route') {
  //       this.street = this.street + ' ' + this.place.address_components[i].long_name;
  //       console.log('route', this.street);
  //     }
  //     if (this.place.address_components[i].types[j] === 'sublocality_level_2') {
  //       this.street = this.street + ' ' + this.place.address_components[i].long_name;
  //       console.log('sublocality 2', this.street);
  //     }
  //     if (this.place.address_components[i].types[j] === 'sublocality_level_1') {
  //       this.street = this.street + ' ' + this.place.address_components[i].long_name;
  //       console.log('sublocality 1', this.street);
  //     }
  //     if (this.place.address_components[i].types[j] === 'administrative_area_level_1') {
  //       // this.state = this.place.address_components[i].long_name;
  //       $('#state').val(this.place.address_components[i].short_name);
  //     }
  //
  //     if (this.place.address_components[i].types[j] === 'country') {
  //       // this.area = this.place.address_components[i].long_name;
  //       $('#area').val(this.place.address_components[i].long_name);
  //     }
  //
  //     if (this.place.address_components[i].types[j] === 'postal_code') {
  //       // this.zip = this.place.address_components[i].long_name;
  //       $('#zip').val(this.place.address_components[i].long_name);
  //     } else {
  //         $('#zip').val('');
  //     }
  //     this.latitude = this.place.geometry.location.lat();
  //       this.longitude = this.place.geometry.location.lng();
  //
  //     }
  //   }
  // }
  //   inputAddress1() {
  //   var context = this;
  //   console.log('inputAddress');
  //
  //   const input = document.getElementById('searchTextField3');
  //
  //   const searchBox = new google.maps.places.Autocomplete(input);
  //   searchBox.addListener('place_changed', function() {
  //
  //     console.log('place changed');
  //     context.place = searchBox.getPlace();
  //     console.log('address', context.place);
  //     context.addressDetail();
  //
  //   });
  // }
  editDriver() {
    this.driverMatch = false;
    var context = this;
    this.callMap();
    $(function () {
      setTimeout(() => {
        $("#phone").on("countrychange", function (e, countryData) {
          console.log("chk in intel input change event");
          if (context.phone === null || context.phone === "") {
            return;
          } else {
            context.findNumber();
          }
        });
        $("#phone").intlTelInput({
          // autoFormat: true,
          utilsScript:
            "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/12.1.9/js/utils.jss",
          autoPlaceholder: false,
          preferredCountries: context.countryCode,
          preventInvalidNumbers: true,
          // stop the user from typing invalid dial codes
          preventInvalidDialCodes: true,
          formatOnDisplay: true,
          separateDialCode: false,
        });
        var countryCode;
        // setTimeout(() => {
        //  countryCode = $('#phone').intlTelInput('getSelectedCountryData').dialCode;
        //  $('#phone').val('+' + countryCode);
        //  $('#phone').val(context.countryCode);
        //  $(function() {
        //    // $('#phone').focus();
        //      console.log('trigger');
        //      var e = $.Event( 'keypress', { which: 13 } );
        //      $('#phone').trigger(e);
        //
        // });
        // }, 1000);
        $(".select-image-btn").click(function () {
          $(".cropit-image-input").click();
        });
        $("#image-cropper").cropit();
      }, 2000);
      var countryCode;
      setTimeout(() => {
        //  countryCode = $('#phone').intlTelInput('getSelectedCountryData').dialCode;
        //  $('#phone').val('+' + countryCode);
        $("#phone").val(context.countryCode);
        $(function () {
          // $('#phone').focus();
          console.log("trigger");
          var e = $.Event("keypress", { which: 13 });
          $("#phone").trigger(e);
        });
      }, 1000);
      $("#phone").change(function () {
        countryCode = $("#phone").intlTelInput("getSelectedCountryData")
          .dialCode;
        $("#phone").val("+" + countryCode);
      });
    });
  }
  countryValidation() {
    var code = $("#phone").intlTelInput("getSelectedCountryData").dialCode;
    code = "+" + code;
    var val = $("#phoneValue").val();
    for (var i = 0; i < this.cs.country.length; i++) {
      if (code === this.cs.country[i].countryCode) {
        // console.log('val.length', val.length, this.cs.country[i].length);
        if (val.length === this.cs.country[i].length) {
          console.log("valid");
          this.numChk = false;
          $("#phoneValue").css("border-color", "#ccc");
        } else {
          console.log("invalid");
          this.numChk = true;
          $("#phoneValue").css("border-color", "#eb3b3b");
        }
      }
    }
  }
  restrictUserInput($event) {
    $event.preventDefault();
  }
  prevent($event) {
    console.log("prevent default", $event.keyCode);
    if ($event.keyCode === 8 || $event.keyCode === 46) {
      return;
    }
    if (!($event.keyCode >= 48 && $event.keyCode <= 57)) {
      $event.preventDefault();
      return;
    }
  }
  editDriverFunction() {
    this.error_count = 0;
    $(".c-label label").css("color", "#3d3e3d");
    $(".uploadText").css("color", "#3d3e3d");
    $(".c-label input").css("border-color", "#ccc");
    $(".c-label textarea").css("border-color", "#ccc");
    this.addDriver = true;
    console.log("login data");
    // this.dob = $('#datepicker').val();
    this.dob = this.dob.formatted;
    this.city = $("#city").val();
    this.zip = $("#zip").val();
    this.state = $("#state").val();
    this.area = $("#area").val();
    this.address_line1 = $("#c-address input").val();
    console.log(
      "chk images",
      this.driving_license_front,
      this.driving_license_back,
      this.registration_book
    );
    // if (this.driving_license_front === undefined) {
    //          $('#c-front label').css('color', '#a10a0d');
    //          this.error_count ++;
    //  }
    //  if (this.driving_license_back === undefined) {
    //        $('#c-back label').css('color', '#a10a0d');
    //        this.error_count ++;
    //  }
    //  if (this.registration_book === undefined) {
    //        $('#c-registration label').css('color', '#a10a0d');
    //        this.error_count ++;
    //  }
    if (this.first_name === "" || this.first_name === undefined) {
      $("#c-fname label").css("color", "#a10a0d");
      $("#c-fname input").css("border-color", "#a10a0d");
      this.error_count++;
    }
    if (this.last_name === "" || this.last_name === undefined) {
      $("#c-lname label").css("color", "#a10a0d");
      $("#c-lname input").css("border-color", "#a10a0d");
      this.error_count++;
    }
    if (this.phone2 !== "" && this.phone2 !== undefined) {
      // && this.numChk === true
      console.log("number", this.phone2, this.numChk);
      var getCode = $("#phone").intlTelInput("getSelectedCountryData").dialCode;
      this.phoneNumToSend = "+" + getCode + "" + this.phone2;
      console.log("number after concat", this.phoneNumToSend);
    }
    // if (this.dob === '' || this.dob === undefined) {
    //             $('#c-dob label').css('color', '#a10a0d');
    //             $('#c-dob input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    if (this.dob === "" || this.dob === undefined) {
      this.dob = this.dobToDisplay;
      // $('#c-dob label').css('color', '#a10a0d');
      // $('#c-dob input').css('border-color', '#a10a0d');
      // this.error_count ++;
    }
    this.emailChk = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!this.emailChk.test(this.email) && this.email !== "") {
      $("#c-email label").css("color", "#a10a0d");
      $("#c-email input").css("border-color", "#a10a0d");
      this.error_count++;
    }
    if (this.address_line1 === "" || this.address_line1 === undefined) {
      $("#c-address label").css("color", "#a10a0d");
      $("#c-address input").css("border-color", "#a10a0d");
      this.error_count++;
    }
    // if (this.address_line2 === '' || this.address_line2 === undefined) {
    //             $('#c-address2 label').css('color', '#a10a0d');
    //             $('#c-address2 input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    if (this.city === "" || this.city === undefined) {
      $("#c-city label").css("color", "#a10a0d");
      $("#c-city input").css("border-color", "#a10a0d");
      this.error_count++;
    }
    if (this.zip === "" || this.zip === undefined) {
      $("#c-zip label").css("color", "#a10a0d");
      $("#c-zip input").css("border-color", "#a10a0d");
      this.error_count++;
    }
    // if (this.state === '' || this.state === undefined) {
    //             $('#c-state label').css('color', '#a10a0d');
    //             $('#c-state input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    // if (this.area === '' || this.area === undefined) {
    //             $('#c-area label').css('color', '#a10a0d');
    //             $('#c-area input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    // if (this.validateChk === true) {
    //              toastr.error('number already exists');
    //             this.error_count ++;
    // }
    // if (this.note === '' || this.note === undefined) {
    //             $('#c-note label').css('color', '#a10a0d');
    //             $('#c-note input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    if (this.error_count > 0) {
      return;
    }
    // var getCode = $('#phone').intlTelInput('getSelectedCountryData').dialCode;
    // this.phone = '+' + getCode + this.phone;
    // console.log('number', this.phone);
    // var getCode = $('#phone').intlTelInput('getSelectedCountryData').dialCode;
    // this.phone2 = '+' + getCode + '' + this.phone2;
    // console.log('number', this.phone);
    this.btnDisable = true;
    this.nao.go(30);
    this.dataService
      .editDriver(
        window.localStorage.getItem("token"),
        this.first_name,
        this.last_name,
        this.phoneNumToSend,
        this.email,
        this.enableEditAccess,
        this.enableQuantity,
        this.enableorder,
        this.dob,
        this.address_line1,
        this.street,
        this.address_line2,
        this.city,
        this.zip,
        this.state,
        this.area,
        this.note,
        this.driving_license_front,
        this.driving_license_back,
        this.registration_book,
        this.id,
        this.latitude,
        this.longitude
      )
      .subscribe(
        (data) => {
          console.log("outlet data");
          this.nao.go(100);
          this.addDriverData = data;
          this.validateChk = true;
          if (this.addDriverData.rest_error_code === 1) {
            toastr.error("Some thing went wrong");
            this.btnDisable = false;
          }
          if (this.addDriverData.rest_error_code === 2) {
            toastr.error("Please login again");
            this.btnDisable = false;
          }
          if (this.addDriverData.rest_error_code === 3) {
            toastr.error("Driver already exists");
            this.btnDisable = false;
          }
          if (this.addDriverData.rest_error_code === 4) {
            toastr.error("Driver does not exist");
            this.btnDisable = false;
          }
          this.success = data;
          this.success = this.success.success;
          if (this.success === true) {
            toastr.success("Successfully updated");
            // this.router.navigate(['drivers']);
            this.editClose();
            this.btnDisable = false;
          }
          if (this.success === false) {
            this.addDriver = false;
            this.btnDisable = false;
          }
        },
        (error) => {
          this.addDriver = false;
          this.btnDisable = false;
          this.nao.go(100);
          console.log("error", error);
        }
      );
  }
  capitlizeFirstName() {
    this.first_name = this.first_name.replace(/\b\w/g, function (l) {
      return l.toUpperCase();
    });
  }
  capitlizeLastName() {
    this.last_name = this.last_name.replace(/\b\w/g, function (l) {
      return l.toUpperCase();
    });
  }
  editClose() {
    this.driverMatch = true;
    $(".intl-tel-input").remove();
    this.driverDetails();
  }
  functionTogetPlace() {
    if (this.selectAddress === true) {
      return;
    }
    this.placeDataFound = false;
    this.placeSuggestionsData = [];
    clearTimeout(this.clearTimeout);
    this.clearTimeout = setTimeout(() => {
      // this.addressLoad = true;
      this.dataService.googleAddress(this.address_line1).subscribe(
        (data) => {
          this.placeSuggestionsData = data;
          this.placeSuggestionsData = this.placeSuggestionsData.predictions;
          console.log("place google data", this.placeSuggestionsData);
          this.placeDataFound = true;
          if ($(".myDrop").hasClass("open")) {
          } else {
            $(".myDrop").addClass("open");
          }
          // this.addressLoad = false;
          // $('#searchTextField').click();
          // $('#searchTextField').focus();
        },
        (error) => { }
      );
    }, 1000);
  }
  functionTogetPlaceDetail(name, id) {
    this.addressLoad = true;
    this.address_line1 = name;
    clearTimeout(this.clearTimeout);
    this.clearTimeout = setTimeout(() => {
      this.dataService.googleAddressDetail(id).subscribe(
        (data) => {
          console.log("place google detail data", data);
          this.placeDetailData = data;
          this.selectAddress = true;
          this.placeDetailData = this.placeDetailData.result;
          this.latitude = this.placeDetailData.geometry.location.lat;
          this.longitude = this.placeDetailData.geometry.location.lng;
          console.log("this.latitude", this.latitude);
          console.log("this.longitude", this.longitude);
          this.placeDetailData = this.placeDetailData.address_components;
          this.callMap();
          setTimeout(() => {
            this.addressDetail();
            this.addressLoad = false;
          }, 1000);
        },
        (error) => { }
      );
    }, 1000);
  }
  addressDetail() {
    this.street = "";
    $("#state").val("");
    console.log("chk address detail", this.place);
    for (var i = 0; i < this.placeDetailData.length; i++) {
      for (var j = 0; j < this.placeDetailData[i].types.length; j++) {
        if (
          this.placeDetailData[i].types[j] === "administrative_area_level_2"
        ) {
          $("#city").val(this.placeDetailData[i].long_name);
        } else if (this.placeDetailData[i].types[j] === "locality") {
          // this.city = this.place.address_components[i].long_name;
          // console.log('city', this.city);
          $("#city").val(this.placeDetailData[i].long_name);
        }
        if (this.placeDetailData[i].types[j] === "street_number") {
          this.street = this.placeDetailData[i].long_name;
          console.log("street number", this.street);
        }
        if (this.placeDetailData[i].types[j] === "route") {
          this.street = this.street + " " + this.placeDetailData[i].long_name;
          console.log("route", this.street);
        }
        if (this.placeDetailData[i].types[j] === "sublocality_level_2") {
          this.street = this.street + " " + this.placeDetailData[i].long_name;
          console.log("sublocality 2", this.street);
        }
        if (this.placeDetailData[i].types[j] === "sublocality_level_1") {
          this.street = this.street + " " + this.placeDetailData[i].long_name;
          console.log("sublocality 1", this.street);
        }
        //   this.street = this.place.name;
        //   console.log('this.street', this.street);

        if (
          this.placeDetailData[i].types[j] === "administrative_area_level_1"
        ) {
          $("#state").val(this.placeDetailData[i].short_name);
        }

        if (this.placeDetailData[i].types[j] === "country") {
          // this.area = this.place.address_components[i].long_name;
          $("#area").val(this.placeDetailData[i].long_name);
        }

        if (this.placeDetailData[i].types[j] === "postal_code") {
          // this.zip = this.place.address_components[i].long_name;
          console.log("postal; code", this.placeDetailData[i].long_name);
          $("#zip").val(this.placeDetailData[i].long_name);
        } else {
          $("#zip").val("");
        }
      }
    }
  }
  callMap() {
    setTimeout(() => {
      var context = this;
      var map;
      var marker;
      var adr;
      var myLatlng = new google.maps.LatLng(this.latitude, this.longitude);
      var geocoder = new google.maps.Geocoder();
      var infowindow = new google.maps.InfoWindow();
      var mapOptions = {
        zoom: 18,
        center: myLatlng,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        navigationControl: false,
        // mapTypeControl: false,
        // disableDefaultUI: true
      };
      var endImage = {
        url: "assets/pin.png", // url
        scaledSize: new google.maps.Size(30, 42), // scaled size
        origin: new google.maps.Point(0, 0), // origin
        anchor: new google.maps.Point(16, 41), // anchor
      };
      map = new google.maps.Map(document.getElementById("myMap"), mapOptions);
      if (this.driverMatch === true) {
        marker = new google.maps.Marker({
          map: map,
          position: myLatlng,
          icon: endImage,
        });
      }
      if (this.driverMatch === false) {
        marker = new google.maps.Marker({
          map: map,
          position: myLatlng,
          draggable: true,
          icon: endImage,
        });
      }
      if (this.driverMatch === false) {
        geocoder.geocode({ latLng: myLatlng }, function (results, status) {
          if (status === google.maps.GeocoderStatus.OK) {
            if (results[0]) {
              // $('#address').val(results[0].formatted_address);
              // $('#latitude').val(marker.getPosition().lat());
              // $('#longitude').val(marker.getPosition().lng());
              infowindow.setContent(results[0].formatted_address);
              infowindow.open(map, marker);
              context.latitude = marker.getPosition().lat();
              context.longitude = marker.getPosition().lng();
              console.log(context.latitude, context.longitude);
              console.log("results", results);
              // context.getDeliveryAddressDetail(results[0]);
            }
          }
        });

        google.maps.event.addListener(marker, "dragend", function () {
          geocoder.geocode({ latLng: marker.getPosition() }, function (
            results,
            status
          ) {
            if (status === google.maps.GeocoderStatus.OK) {
              if (results[0]) {
                infowindow.setContent(results[0].formatted_address);
                infowindow.open(map, marker);
                context.latitude = marker.getPosition().lat();
                context.longitude = marker.getPosition().lng();
                // context.addressNew =  results[0].formatted_address;
                console.log(context.latitude, context.longitude);
                console.log("results", results);
                // this.changeRef.detectChanges();
                // context.getDeliveryAddressDetail(results[0]);
              }
            }
          });
        });
      }
    }, 500);
  }
  resetAddress() {
    this.address_line1 = "";
    // this.address_line2 = '';
    this.city = "";
    this.state = "";
    this.zip = "";
    this.area = "";
    // this.apart = '';
    this.longitude = "";
    this.latitude = "";
    this.selectAddress = false;
  }
  backToDriversListing() {
    this.businessIdForOrders = -1;
    this.businessForOrders = 'Businesses - All';
    this.dateType = -1;
    this.filter_id = -1;
    this.serviceCityForOrders = 'Services - All';
    this.filterValue = 'Order-All';
    this.city_id = 'All';
    this.searchBusinessDetailforOrder = [];
    $(".intl-tel-input").remove();
    var data = {
      id: this.id,
      page: this.previousState.page,
      scroll: this.previousState.scroll,
    };
    this.events.publish("driverDetailUpdateDone", data);
  }
  ngOnInit() {
    const context = this;
    // this.inputAddress1();
    // this.driverDetails();
    $(document).ready(function () {
      $(this).scrollTop(0);
    });
    $(function () {
      this.maxYear = new Date().getFullYear();
      this.maxYear = parseInt(this.maxYear) - 21;
      $("#datepicker").datepicker({
        format: "mm/dd/yyyy", // Notice the Extra space at the beginning
        defaultDate: "-10d",
        endDate: new Date("12/31/" + this.maxYear),
      });
    });

    $(function () {
      $("#front").change(function () {
        console.log("image change", this.files[0]);
        if (this.files && this.files[0]) {
          var reader = new FileReader();
          // this.driving_license_front = this.files[0];
          // console.log('file 1 front cover chk', this.driving_license_front);
          reader.onload = function (file) {
            context.driving_license_front = file.target;
            context.driving_license_front =
              context.driving_license_front.result;
            console.log("base 64 1 image chk", context.driving_license_front);
            return imageIsLoadedFront(file);
          };
          reader.readAsDataURL(this.files[0]);
        }
      });

      $("#back").change(function () {
        console.log("image change", this.files[0]);
        if (this.files && this.files[0]) {
          var reader2 = new FileReader();
          // context.uploadImageFunction(this.files[0]);
          reader2.onload = function (file) {
            context.driving_license_back = file.target;
            context.driving_license_back = context.driving_license_back.result;
            console.log("base 64 2 image chk", context.driving_license_back);
            return imageIsLoadedBack(file);
          };
          reader2.readAsDataURL(this.files[0]);
        }
      });

      $("#registration").change(function () {
        console.log("image change", this.files[0]);
        if (this.files && this.files[0]) {
          var reader3 = new FileReader();
          // context.uploadImageFunction(this.files[0]);
          reader3.onload = function (file) {
            context.registration_book = file.target;
            context.registration_book = context.registration_book.result;
            console.log("base 64 3 image chk", context.registration_book);
            return imageIsLoadedRegister(file);
          };
          reader3.readAsDataURL(this.files[0]);
        }
      });
    });

    function imageIsLoadedFront(e) {
      $("#pImg1").attr("src", e.target.result);
    }
    function imageIsLoadedBack(e) {
      $("#pImg2").attr("src", e.target.result);
    }
    function imageIsLoadedRegister(e) {
      $("#pImg3").attr("src", e.target.result);
    }
  }
  createOrder(id, name) {
    this.businessIdForOrders = id;
    this.businessForOrders = name;
    this.getOrderHistory();
  }
  searchSpecificBusiness() {
    clearTimeout(this.searchTimeOut);
    this.searchTimeOut = setTimeout(() => {
      this.dataService.getdispensaryListingById(localStorage.getItem('token'), this.serviceCity, this.searchBusiness).subscribe(
        (data) => {
          this.showSearchResults = true;
          this.searchBusinessDetailforOrder = data;
        },
        (error) => {
          console.log('error', error);
          toastr.error('Some thing went wrong');
        }
      );
    });
  }
  getServices() {

    this.dataService.getservices(localStorage.getItem('token')).subscribe(
      (data) => {
        this.servicesDatas = data;
        this.servicesDatas = this.servicesDatas.city_list;

      },
      (error) => {
        // this.nao.go(100);
        console.log('error', error);
        toastr.error('Some thing went wrong');
      }
    );
  }
  createOrderService(id, cityName, random = '') {
    this.serviceCityIdForOrders = id;
    if (cityName == 'Services - All') {
      this.serviceCityForOrders = 'Services - All';
      this.serviceCity = '';
      this.city_id = id;
    } else {
      this.serviceCityForOrders = cityName;
      this.serviceCity = cityName;
      this.city_id = id;
    }
    this.dataService.getdispensaryListingById(localStorage.getItem('token'), this.serviceCity, '').subscribe(
      (data) => {
        this.businessDetailforOrder = data;
        this.searchBusinessDetailforOrder = data;
      },
      (error) => {
        console.log('error', error);
        toastr.error('Something went wrong');
      }
    );
    this.getOrderHistory();
  }
  filterBusinessId(id, name, detail) {
    this.dispensary_id = id;
    this.businessIdForOrders = id;
    this.getOrderHistory();

    if (this.dispensary_id == -1) {
      this.businessName = 'All Businesses';
      this.businessForOrders = 'All Businesses';
    }

    if (this.dispensary_id != -1) {
      this.businessName = name;

    }

    console.log('dispansaryid', id);
    // this.outlets();
    // this.outletId = -1;
  }
  getOrderHistory() {
    this.page = 0;
    let data = {
      auth_token: window.localStorage.getItem("token"),
      driver_id: this.id,
      order_filter: this.filter_id,
      search: this.searchOrder,
      date_type: this.dateType,
      page: this.page,
      startDate: this.startDate,
      endDate: this.endDate,
      version_number: null,
      business_id: this.businessIdForOrders,
      city_id: this.city_id
    };
    this.nao.go(30);
    this.dataService.getDriverOrderHistory(data).subscribe(
      (data) => {
        this.nao.go(70);
        this.loadingData = false;
        this.driverOrder = data;
        this.driverOrderListing = this.driverOrder.items;
        this.totalOrders = this.driverOrder.total;
        if (this.driverOrderListing) {
          for(let i = this.driverOrderListing.length - 1; i >= 0; i--) {
            this.driverOrderListing[i].created_on = this.driverOrderListing[i].created_on === this._none ? this._none : this.dataService.convertToUTC(this.driverOrderListing[i].created_on);
            this.driverOrderListing[i].pickup_on = this.driverOrderListing[i].pickup_on === this._none ? this._none : this.dataService.convertToUTC(this.driverOrderListing[i].pickup_on);
            this.driverOrderListing[i].updated_on = this.driverOrderListing[i].updated_on === this._none ? this._none : this.dataService.convertToUTC(this.driverOrderListing[i].updated_on);
            var previousLat, previousLng;
            if(this.driverOrderListing[i].dropoff_latitude != this._none){
              // console.log("order", i + 1, this.driverOrderListing[i].dropoff_latitude, this.driverOrderListing[i].dropoff_longitude);
              if(previousLat) {
                // console.log('previous', i + 1, previousLat, previousLng)
                this.driverOrderListing[i].location_difference = this.calculate_distance(previousLat, previousLng, this.driverOrderListing[i].dropoff_latitude, this.driverOrderListing[i].dropoff_longitude) 
                // console.log('order : ', i + 1, this.driverOrderListing[i].location_difference);
              }
              previousLat = this.driverOrderListing[i].dropoff_latitude
              previousLng = this.driverOrderListing[i].dropoff_longitude
            }
          }
        }
        this.lastPageHistory = this.driverOrder.last_page;
        if (this.driverOrderListing) {
          if (this.driverOrderListing.length == 0) {
            this.noSearchData = true;
          }
          else {
            this.noSearchData = false;
          }
        }
        this.nao.go(100);
      },
      (error) => {
        this.nao.go(100);
        console.log(error);
      }
    );
  }

  calculate_distance(pos1lat, pos1lng, pos2lat, pos2lng): string {
    var R = 6378.1; // Radius of the Earth in km
    var rlat1 = pos1lat * (Math.PI/180); // Convert degrees to radians
    var rlat2 = pos2lat * (Math.PI/180); // Convert degrees to radians
    var difflat = rlat2-rlat1; // Radian difference (latitudes)
    var difflon = (pos2lng-pos1lng) * (Math.PI/180); // Radian difference (longitudes)

    var d = 2 * R * Math.asin(Math.sqrt(Math.sin(difflat/2)*Math.sin(difflat/2)+Math.cos(rlat1)*Math.cos(rlat2)*Math.sin(difflon/2)*Math.sin(difflon/2)));
    return d.toFixed(2); // * return distance in Km.
  }

  updateData(type) {
    this.startDate = undefined;
    this.endDate = undefined;
    if (type === "all") {
      this.showRangeFields = false;
      this.dateType = -1;
      this.getOrderHistory();
      return;
    }
    if (type === "today") {
      this.showRangeFields = false;
      this.dateType = 0;
      this.getOrderHistory();
      return;
    }
    if (type === "weekly") {
      this.showRangeFields = false;
      this.dateType = 1;
      this.getOrderHistory();
      return;
    }
    if (type === "monthly") {
      this.showRangeFields = false;
      this.dateType = 2;
      this.getOrderHistory();
      return;
    }
    if (type === "selectRange") {
      this.showRangeFields = true;
      this.dateType = 3;
      setTimeout(() => {
        $(" #driverOrderStart, #driverOrderEnd").datepicker({
          format: "yyyy-m-d", // Notice the Extra space at the beginning
          defaultDate: "-10d",
          endDate: new Date(),
        });
      }, 10);
    }
  }
  sendRangeData() {
    this.startDate = $("#driverOrderStart").val();
    this.endDate = $("#driverOrderEnd").val();
    if (this.startDate === "" || this.startDate === undefined) {
      toastr.error("please select start date");
      return;
    }
    if (this.endDate === "" || this.endDate === undefined) {
      toastr.error("please select end date");
      return;
    }
    console.log("this.startDate,this.endDate", this.startDate, this.endDate);
    this.dateType = 3;
    this.getOrderHistory();
  }
  getupdateorderfilter(name, id) {
    if (name == 'All') {
      this.filterValue = 'order-' + name;
    }
    else {
      this.filterValue = name;
    }
    this.filter_id = id;
    this.getOrderHistory();
  }
  filterOrderSearch() {
    this.noSearchData = false;
    clearTimeout(this.searchTimeOut);
    this.searchTimeOut = setTimeout(() => {
      this.getOrderHistory();
    }, 1000);
    if (this.driverOrderListing.length === 0) {
      this.noSearchData = true;
    }
  }
  clearSearch() {
    this.searchOrder = "";
    this.getOrderHistory();
  }
  Pagination() {
    this.paginationBtn = true;
    this.page++;
    this.pagination = [];
    let data = {
      auth_token: window.localStorage.getItem("token"),
      driver_id: this.id,
      order_filter: this.filter_id,
      search: this.searchOrder,
      date_type: this.dateType,
      page: this.page,
      startDate: this.startDate,
      endDate: this.endDate,
      version_number: null,
      business_id: this.businessIdForOrders,
      city_id: this.city_id
    };
    this.nao.go(30);
    this.dataService.getDriverOrderHistory(data).subscribe(
      (data) => {
        this.nao.go(70);
        this.driverOrder = data;
        this.pagination = this.driverOrder.items;
        this.lastPageHistory = this.driverOrder.last_page;
        this.totalOrders = this.driverOrder.total;
        if (this.pagination.length > 0) {
          for (let i = 0; i < this.pagination.length; i++) {
            this.pagination[i].created_on = this.pagination[i].created_on === this._none ? this._none : this.dataService.convertToUTC(this.pagination[i].created_on);
            this.pagination[i].pickup_on = this.pagination[i].pickup_on === this._none ? this._none : this.dataService.convertToUTC(this.pagination[i].pickup_on);
            this.driverOrderListing.push(this.pagination[i]);
          }
        }
        console.log(this.driverOrderListing);

        this.nao.go(100);
        this.paginationBtn = false;
      },
      (error) => {
        this.nao.go(100);
        console.log(error);
      }
    );
  }
  orderDetailCall(id) {

    this.orderDetailToReopenOpId = id;
    this.dataService.getOrderhDetail(window.localStorage.getItem('token'), id).subscribe(
      (data) => {
        this.orderDetailData = data;

        console.log('orderdetailcall', this.orderDetailData);

        this.customerDetail = this.orderDetailData.customer_detail;
        this.droppOffAddress = this.orderDetailData.dropoff_address;
        this.userDropDocs = this.orderDetailData.drop_off_docs;
        console.log('userDropDocs', this.userDropDocs);
        this.orderDataDisplay = this.orderDetailData.order;
        let order_type = this.orderDataDisplay.delivery_man_type;
        if (order_type === 4) {
          this.dineIn = true;
          this.tableNo = this.orderDataDisplay.dine_in_table_number;
        } else {
          this.dineIn = false;
          this.tableNo = '';
        }
        if (order_type === 5) {
          this.pickUp = true;
        } else {
          this.pickUp = false;
        }
        this.pickupAddress = this.orderDetailData.pickup_address;
        this.productData = this.orderDetailData.product;
        this.thirdPartyData = this.orderDetailData.third_party;
        this.onDetailDriverData = this.orderDetailData.driver;
        this.returnOrderItems = this.orderDataDisplay.return_items['return_product_list'];
        this.returnOrderItemsLength = this.returnOrderItems.length;
        this.orderCreated = this.orderDetailData.order_created_by;
        this.orderBooked = this.orderDetailData.order_booked_by;
        console.log('this.onDetailDriverData', this.onDetailDriverData);
        $('#orderDetailPop').modal('show');

        var cDate = new Date().getDate();
        var cYear = new Date().getFullYear();
        var cMonth = new Date().getUTCMonth() + 1;
        var openTime = this.orderDataDisplay.open_time;
        var tOpen = cYear + '/' + cMonth + '/' + cDate + ' ' + openTime + ' ' + 'UTC';
        var dateObjOpen = new Date(tOpen);
        this.deliverStartDate = dateObjOpen;

        var closeTime = this.orderDataDisplay.close_time;
        var tClose = cYear + '/' + cMonth + '/' + cDate + ' ' + closeTime + ' ' + 'UTC';
        var dateObjClose = new Date(tClose);
        this.deliverEndDate = dateObjClose;
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/driver-detail/driver-detail.component.ts